module.exports = "/v2/pages/dashboard/dist/154be46abb7f69f96e19bd40c87b8c0e.svg";